<template>
  <div
    style="
      margin: -20px -30px -30px -20px;
      padding: 20px 30px 30px;
      background: #f6f7f8;
    "
  >
    <!-- 标题 -->
    <div class="page-title" style="margin-bottom: 15px">
      {{ page_title }}草稿
    </div>
    <!-- <div style="display: flex;align-items: center;margin: 0 auto 15px;width: 1260px;">
		<div class="screen-box">
			<a-input v-model="r_name" allowClear placeholder="请输入模板标题" style="width: 370px;"/>
		</div>
		<div class="screen-box" style="">
			<a-select
				show-search
				style="width: 370px;height: 32px;"
				placeholder="请选择书城"
				@change="handleChangeF"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				allowClear
				:value="r_channel_id"
			  >
				<a-select-option v-for="(value,key) in bookObj" :key="key" :value="key">
				  {{value.channel_name}}
				</a-select-option>
			</a-select>
		</div>
	</div> -->

    <div
      style="
        display: flex;
        justify-content: space-between;
        width: 1260px;
        margin: 0 auto;
      "
    >
      <!-- 左侧内容 -->
      <div style="">
        <div class="left-box box-radius">
          <div
            @click="changeMaterial(item, index)"
            v-for="(item, index) in contentData"
            :key="item.for_id"
          >
            <!-- 第一个素材-大图显示 -->
            <div
              v-if="index == 0"
              @click="changeMaterial(contentData[0], 0)"
              class="left-cell-top"
              :class="[contentData[0].select_status ? 'left-box-border' : '']"
            >
              <img
                v-if="contentData[0].local_thumb_url"
                style="width: 100%; height: 150px"
                :src="contentData[0].local_thumb_url"
                alt=""
              />
              <div
                v-else
                style="width: 100%; height: 150px; border: 1px solid #ccc"
              ></div>
              <div class="left-top-title">
                {{ contentData[0].title || "标题" }}
              </div>
            </div>
            <!-- 第一个后面的素材 -->
            <div
              v-if="index > 0"
              class="left-cell-box"
              :class="[
                item.select_status ? 'left-box-border' : 'left-cell-box-boder',
              ]"
            >
              <div style="flex: 1">{{ item.title || "标题" }}</div>
              <img
                v-if="item.local_thumb_url"
                class="left-cell-img"
                :src="item.local_thumb_url"
                alt=""
              />
              <div
                v-else
                class="left-cell-img"
                style="border: 1px solid #ccc"
              ></div>
            </div>
          </div>

          <div @click="addContent" class="left-cell-add" style="">
            + 新建素材
          </div>
        </div>
      </div>

      <!-- 中间内容，包括标题、富文本 -->
      <div style="max-width: 628px; margin: 0 30px">
        <div
          style="padding: 30px 35px; background-color: #fff"
          class="box-radius"
        >
          <div id="title-select-mousedown" style="position: relative">
            <a-input
              v-model="contentData[content_index].title"
              @blur="titleInputBlur"
              @change="titleInputChange"
              @focus="titleInputFocus"
              size="large"
              placeholder="文章标题"
              style="width: 100%"
            />

            <div v-show="title_select_control" class="title-select-box">
              <div
                @click="selectTitleCell(item)"
                class="title-select-cell"
                v-for="(item, index) in titleSelectData"
                :key="index"
              >
                {{ item.content }}
              </div>
            </div>
          </div>

          <a-input
            v-model="contentData[content_index].author"
            placeholder="作者，选填，默认为公众号名称"
            style="width: 100%; margin-top: 20px"
          />

          <!-- 富文本 -->
          <div style="width: 100%; margin-top: 20px">
            <Editor
              id="tinymce"
              v-model="contentData[content_index].content_show"
              :init="init"
            ></Editor>
          </div>

          <!-- <div style="margin: 30px 0 30px;border:1px dashed #d9d9d9;">
					<div style="cursor: pointer;" @click="selectImg('2')">
						<img v-if="contentData[content_index].message_show_foot_img"
						 :src="contentData[content_index].message_show_foot_img" style="width: 100%;height: 130px;object-fit: contain;" alt="">
						<div v-else style="height: 130px;display: flex;align-items: center;justify-content: center;color: #999;">
							二维码底图 -- 点击添加 / 更换
						</div>
					</div>
				</div> -->

          <!-- <div style="margin: 30px 0 30px;border:1px dashed #d9d9d9;">
					<div style="cursor: pointer;" @click="selectImg('3')">
						<img v-if="contentData[content_index].message_continue_read" 
						:src="contentData[content_index].message_continue_read" style="width: 100%;height: 130px;object-fit: contain;" alt="阅读原文提示">
						<div v-else style="height: 130px;display: flex;align-items: center;justify-content: center;color: #999;">
							阅读原文提示图片 -- 点击添加 / 更换
						</div>
					</div>
				</div> -->
        </div>

        <div style="position: sticky; bottom: 0">
          <div
            style="width: 100%; height: 13px; background-color: #f6f7f8"
          ></div>
          <div
            class="form-cell-box box-radius"
            style="padding: 20px 30px; background-color: #fff"
          >
            <a-button
              @click="addRequest"
              type="primary"
              style="margin-right: 20px"
              >确认</a-button
            >
            <a-button @click="cancelButton">取消</a-button>
          </div>
        </div>
      </div>

      <!-- 右侧内容 -->
      <div style="width: 300px; flex-shrink: 0">
        <div style="">
          <!-- <div style="padding: 20px 25px;background-color: #fff;" class="box-radius">
					<div style="font-size: 16px;font-weight: 600;margin-bottom: 15px;">设置 二维码 与 原文链接</div>
					<div>二维码 与 原文链接 添加方式：</div>
					<div style="margin: 7px 0 20px 0;">
						<a-radio-group @change="radioChangeA" name="radioGroup" :value="1">
							<a-radio :value="1">
							  自动生成
							</a-radio>
						</a-radio-group>
					</div>
					
					
					<a-input v-model="contentData[content_index].spread_name" allowClear placeholder="推广链接名称" style="width: 100%;margin-bottom: 20px;"/>
					
					<a-radio-group @change="radioChangeB" name="radioGroup"  style="margin-bottom:20px;"
					:value="contentData[content_index].spread_type" >
						<a-radio :value="1">
						  内推链接
						</a-radio>
						<a-radio :value="0">
						  外推链接
						</a-radio>
					</a-radio-group>
					<div style="margin-bottom:20px;">
						<a-select
							style="width: 100%;"
							placeholder="阅读类型"
							@change="handleChangeB"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							:value="contentData[content_index].read_type"
						  >
							<a-select-option :value="1">
							  继续阅读某本书
							</a-select-option>
						</a-select>
					</div>
					
					<template v-if="!r_channel_id">
						<div style="margin-bottom: 7px;display: flex;align-items: center;">
							<div>设置作品信息：</div>
						</div>
						<div>请先选择书城，方可设置作品信息</div>
					</template>
					
					<template v-else-if="r_channel_id && !channel_parent">
						<div style="margin-bottom: 7px;display: flex;align-items: center;">
							<div>设置作品信息：</div>
						</div>
						<div @click="goPage(1)" style="cursor: pointer;">没有父类渠道，点击前往设置</div>
					</template>
					
					<template v-else-if="r_channel_id && channel_parent">
						<div style="margin-bottom: 7px;display: flex;align-items: center;">
							<div>设置作品信息：</div>
							<a-button  v-if=" channel_parent.indexOf('文鼎') > -1 || channel_parent.indexOf('迈步') > -1  || channel_parent.indexOf('阳光') > -1 || channel_parent.indexOf('阅文') > -1 || channel_parent.indexOf('掌中') > -1"
							 size="small" @click="resolveUrl" type="primary" >解析推广链接</a-button>
						</div>
						
						<a-input v-if="channel_parent == '乐读' || channel_parent == '掌读' || channel_parent == '文鼎'  || channel_parent.indexOf('阳光') > -1 || channel_parent.indexOf('阅文') > -1  || channel_parent.indexOf('花生') > -1" 
						v-model="contentData[content_index].spread_book_id" allowClear placeholder="请填写作品ID" 
						style="width: 100%;margin-bottom: 20px;"/>
						
						<a-input v-if="channel_parent == '乐读' || channel_parent == '掌读' || channel_parent.indexOf('阳光') > -1" 
						v-model="contentData[content_index].spread_chapter_id" allowClear placeholder="输入章节序号" style="width: 100%;" />
						
						<a-input v-else-if="channel_parent == '文鼎' || channel_parent.indexOf('迈步') > -1 || channel_parent.indexOf('阅文') > -1 || channel_parent.indexOf('掌中') > -1 || channel_parent.indexOf('花生') > -1" 
						v-model="contentData[content_index].spread_chapter_id" allowClear placeholder="输入章节ID" style="width: 100%;" />
					</template>
				</div>
				
				<div style="width: 100%;height: 20px;background-color: #f6f7f8;"></div> -->

          <div
            style="padding: 20px 25px; background-color: #fff"
            class="box-radius"
          >
            <div style="display: flex; align-items: center">
              <div
                style="margin-right: 30px; font-size: 16px; font-weight: 600"
              >
                设置封面
              </div>
              <!-- <a-button @click="selectImg('1')">选择封面</a-button> -->
            </div>
            <div
              @click="selectImg('1')"
              style="
                margin: 12px 0 0;
                border: 1px dashed #d9d9d9;
                cursor: pointer;
              "
            >
              <img
                v-if="contentData[content_index].local_thumb_url"
                :src="contentData[content_index].local_thumb_url"
                style="width: 100%; height: 150px; object-fit: contain"
                alt=""
              />
              <div
                v-else
                style="
                  height: 150px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #999;
                "
              >
                图片展示区域
              </div>
            </div>

            <!-- <div style="display: flex;align-items: center;margin-top: 20px;">
						<div style="margin-right: 30px;flex-shrink: 0;">摘要</div>
						<a-textarea
						    v-model="contentData[content_index]"
						    placeholder="选填，摘要会在订阅号消息、转发链接等文章外的场景显露，帮助读者快速了解内容，如不填写则默认抓取正文前54字"
						    :auto-size="{ minRows: 5, maxRows: 8 }" 
							:maxLength="120"
						/>
					</div> -->
          </div>
        </div>
      </div>
    </div>

    <a-modal
      title="图库"
      :visible="img_visible"
      :confirm-loading="img_confirmLoading"
      @ok="imgHandleOk"
      @cancel="imgHandleCancel"
      width="1100px"
    >
      <div style="position: relative; margin: -24px; padding: 24px">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <a-tabs :activeKey="img_type" @change="imgCallback" style="flex: 1">
            <a-tab-pane key="1" tab="封面图"></a-tab-pane>
            <a-tab-pane key="2" tab="二维码的背景图"></a-tab-pane>
            <a-tab-pane key="3" tab="阅读原文提示图"></a-tab-pane>
          </a-tabs>

          <a-upload
            v-show="img_type == 1"
            accept="image/*"
            name="file"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="`${$http.excel_url}api/common/upload-image`"
            :data="{
              name: 'Image.png',
              type: 4,
              material_type: 2, // 2=封面图，4=继续阅读底图，5=文章顶图
            }"
            :headers="{
              Authorization: headers_token,
            }"
            :withCredentials="true"
            method="post"
            :before-upload="beforeUpload"
            @change="uploadChange"
          >
            <a-button type="primary" style="margin-left: 30px">
              <a-icon type="upload" />本地上传
            </a-button>
          </a-upload>

          <a-upload
            v-show="img_type == 3"
            accept="image/*"
            name="file"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="`${$http.excel_url}api/common/upload-image`"
            :data="{
              name: 'Image.png',
              type: 4,
              material_type: 4, // 2=封面图，4=继续阅读底图，5=文章顶图
            }"
            :headers="{
              Authorization: headers_token,
            }"
            :withCredentials="true"
            method="post"
            :before-upload="beforeUpload"
            @change="uploadChange"
          >
            <a-button type="primary" style="margin-left: 30px">
              <a-icon type="upload" />本地上传
            </a-button>
          </a-upload>
        </div>
        <div v-show="img_type == '1'">
          <!-- 选择封面 -->
          <img
            v-for="(item, index) in fmImgData"
            @click="clickFmImg(index)"
            :class="[item.select_img ? 'select_img-border' : '']"
            style="
              width: 330px;
              height: 130px;
              margin: 0 20px 15px 0;
              cursor: pointer;
              object-fit: contain;
              border: 1px solid #eee;
            "
            :src="item.content"
            alt=""
          />
          <!-- 内容为空提示 -->
          <div class="img-content-null" v-show="fmImgData.length == 0">
            <a-icon style="font-size: 70px; color: #999" type="file-search" />
            <div class="img-content-null-text">内容为空</div>
          </div>
        </div>
        <div v-show="img_type == '2'">
          <!-- 二维码图片 -->
          <img
            v-for="(item, index) in ewmImgData"
            @click="clickEwmImg(index)"
            :class="[item.select_img ? 'select_img-border' : '']"
            style="
              width: 330px;
              height: 115px;
              margin: 0 20px 15px 0;
              cursor: pointer;
            "
            :src="item.content"
            alt=""
          />
          <!-- 内容为空提示 -->
          <div class="img-content-null" v-show="ewmImgData.length == 0">
            <a-icon style="font-size: 70px; color: #999" type="file-search" />
            <div class="img-content-null-text">内容为空</div>
          </div>
        </div>
        <div v-show="img_type == '3'">
          <!-- 阅读原文提示图 -->
          <img
            v-for="(item, index) in ydywData"
            @click="clickYdywImg(index)"
            :class="[item.select_img ? 'select_img-border' : '']"
            style="
              width: 330px;
              height: 130px;
              margin: 0 20px 15px 0;
              cursor: pointer;
              object-fit: contain;
              border: 1px solid #eee;
            "
            :src="item.content"
            alt=""
          />
          <!-- 内容为空提示 -->
          <div class="img-content-null" v-show="ydywData.length == 0">
            <a-icon style="font-size: 70px; color: #999" type="file-search" />
            <div class="img-content-null-text">内容为空</div>
          </div>
        </div>
        <a-pagination
          v-model="img_page"
          :total="show_img_total"
          @change="imgPagingChange"
          style="text-align: center; margin-top: 15px"
        />

        <div class="img_loading" v-show="img_search_loading">
          <a-spin size="large" />
        </div>
      </div>
    </a-modal>

    <a-modal
      title="解析推广链接"
      :visible="url_visible"
      :confirm-loading="url_confirmLoading"
      @ok="urlHandleOk"
      @cancel="urlHandleCancel"
      width="700px"
      okText="解析"
    >
      <div>
        <a-textarea
          v-model="r_url"
          placeholder="请输入推广链接，用于解析"
          :auto-size="{ minRows: 3, maxRows: 10 }"
        />
      </div>
    </a-modal>

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import tinymce from "tinymce";
import "tinymce/themes/silver";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/icons/default/icons";
import "tinymce/themes/silver/theme";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount";

import {
  landAddUploadImage,
  materialLocalMessage,
  materialAdd,
  materialInfo,
  materialEdit,
  materialCodeUrl,
  materialSelectChannel,
  wxDraftInfo,
} from "@/request/api";
export default {
  name: "materialAdd_",
  components: { Editor },
  data() {
    return {
      // 富文本开始
      value: "",
      contenyt: {},
      init: {
        language_url: "/zh_CN.js", // 语言包位置，因为放在public下所以可以省略public
        selector: "#tinymce", //tinymce的id
        language: "zh_CN", //语言类型
        skin_url: "/skins/ui/oxide",
        height: 800, //编辑器高度
        branding: false, //是否禁用 branding水印
        forced_root_block: false, // 强制根节点块元素
        content_style: "img,section {max-width:100% !important;}",
        // browser_spellcheck: true, // 拼写检查
        // elementpath: false, //禁用编辑器底部的状态栏
        // statusbar: false, // 隐藏编辑器底部的状态栏
        paste_data_images: true, // 允许粘贴图像
        image_dimensions: false, // 取消图片上传时输入宽高，避免图片无法自适应
        // menubar: false, //最顶部文字信息
        plugins: "image link code table lists wordcount",
        branding: false, //是否禁用“Powered by TinyMCE”
        toolbar:
          "fontselect fontsizeselect link lineheight forecolor backcolor bold italic underline | alignleft aligncenter alignright alignjustify | image quicklink h2 h3 blockquote table numlist bullist preview fullscreen", //工具栏
        fontsize_formats: "12px 14px 15px 16px 18px 24px 36px 48px 56px 72px",
        font_formats:
          "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;",

        images_upload_handler: function (blobInfo, succFun, failFun) {
          console.log("blobInfo", blobInfo);

          var file = blobInfo.blob(); //转化为易于理解的file对象

          var params = new FormData();
          params.append("file", file);
          params.append("type", 5);

          // file 即选中的文件
          // 自己实现上传，并得到图片 url alt href
          landAddUploadImage(params).then((res) => {
            console.log("微信图文消息", res);

            // 最后插入图片。这里传入图片链接就可以
            succFun(res.data.data.url);
          });
        },
      },
      // 富文本结束

      search_button_loading: false,
      img_search_loading: false, // 图库的加载

      r_editor: "",
      bookObj: {},

      r_name: null,
      r_channel_id: undefined,

      contentData: [
        // 本地图文模板数据
        {
          for_id: 111, // 用于for循环的id，因为要删除，然后不指定唯一id的话，会报错，不能用索引，会乱
          build_qrcode: "1", // 生成二维码，1=自动生成
          spread_name: "", // 推广链接名称
          spread_type: 1, // 推广链接类型，0=外推，1=内推
          read_type: 1, // 阅读类型，1=继续阅读，2=历史记录
          message_title: "", // 微信图文标题
          message_auth: "", // 微信图文作者
          message_content: "<p><br></p>", // 正文。<p><br></p>这是默认值，得用html标签的形式，不能用""或null之类的
          message_cover: "", // 封面
          message_foot_img: "", // 图文底图
          message_continue_read: "", // 继续阅读底图
          spread_book_id: null, // 推广书籍第三方id：read_type=1必传
          spread_chapter_id: null, // 推广书籍章节：read_type=1必传
          select_status: true, // 选中状态,true为选中,false为不选中
          message_show_foot_img: "", // 用于显示的二维码底图
        },
      ],
      content_index: 0, // 第几个素材的索引

      img_visible: false, // 图库弹窗
      img_confirmLoading: false,
      img_type: "1", // 1为选择封面。2为选择二维码底图。3为选择阅读原文提示图片
      img_page: 1, // 图库弹窗里的分页
      img_limit: 9, // 一页多少条
      show_img_total: 0, // 用于弹窗显示的总数
      ewm_total: 0, // 总数
      ewmImgData: [], // 二维码底图
      fmImgData: [], // 封面图
      ydywData: [], // 阅读原文提示图

      ewm_select_img_url: "", // 图库里选中的二维码底图
      ewm_show_img_url: "", // 图库里选中的二维码底图-用于显示
      fm_select_img_url: "", // 图库里选中的图片
      ydyw_select_img_url: "", // 图库里选中的阅读原文提示图

      headers_token: "", // 图片上传用的token

      page_title: "编辑", // 标题。新建or编辑
      r_edit_id: null, // 用于编辑的id
      editIdData: [], // 获取详情里的id。

      // 解析url
      url_visible: false,
      url_confirmLoading: false,
      r_url: "", // 填入的解析的url

      channel_parent: "", // 父类渠道
      a_channel: "乐读、掌读",
      b_channel: "文鼎、迈步、阳光、阅文、掌中云",

      title_select_control: false, // 标题的历史标题下拉框控制
      titleSelectData: [],
    };
  },
  mounted() {
    let that = this;

    console.log(this.$route.query);

    // 用于标题的下拉框控制
    window.addEventListener("mousedown", (e) => {
      // console.log("mousedown",e);
      // 获取被点击的元素
      const clickedEl = e.target;

      // `el` 是你正在检测外部点击的元素
      if (
        document.getElementById("title-select-mousedown").contains(clickedEl)
      ) {
        // 单击“el”内部
        console.log("单击“el”内部");
      } else {
        // 在`el`之外点击
        console.log("在`el`之外点击");
        that.title_select_control = false;
      }
    });

    // 富文本
    tinymce.init({});

    // 图片上传用的token
    this.headers_token = "Bearer " + localStorage.getItem("access_token");

    // 编辑
    if (that.$route.query) {
      if (that.$route.query.edit_id) {
        that.r_edit_id = that.$route.query.edit_id;
        that.page_title = "编辑";
        that.search_button_loading = true;
        wxDraftInfo({
          id: that.$route.query.edit_id,
        }).then((res) => {
          that.search_button_loading = false;
          console.log("编辑获取详情", res);
          // that.r_name = res.data.data.info.name
          // that.r_channel_id = res.data.data.info.channel_id.toString()
          let data = res.data.data.info.url;
          data.forEach((res) => {
            // res.message_show_foot_img = 'https://wx-admin.test.gzlize.com/qrcode-back' + res.message_foot_img
            res.select_status = false;
            res.content_show = this.escape2Html(res.content);
          });
          data[0].select_status = true;
          that.contentData = data;
          console.log("编辑内容", that.contentData);
        });
      }
    }
  },

  methods: {
    // 富文本转义
    escape2Html(str) {
      var arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
        return arrEntities[t];
      });
    },

    customPaste(editor, event, callback) {
      // JS 语法

      // event 是 ClipboardEvent 类型，可以拿到粘贴的数据
      // 可参考 https://developer.mozilla.org/zh-CN/docs/Web/API/ClipboardEvent

      const htmls = event.clipboardData.getData("text/html"); // 获取粘贴的 html
      // const text = event.clipboardData.getData('text/plain') // 获取粘贴的纯文本
      // const rtf = event.clipboardData.getData('text/rtf') // 获取 rtf 数据（如从 word wsp 复制粘贴）
      console.log("htmls", htmls);
      this.contentData[this.content_index].content = htmls;
      // 同步
      // editor.insertText('xxx')

      // 异步
      // setTimeout(() => {
      //     editor.insertText('yy')
      // }, 1000)

      // 阻止默认的粘贴行为
      event.preventDefault();
      callback(false); // 返回值（注意，vue 事件的返回值，不能用 return）

      // 返回 true ，继续默认的粘贴行为
      // callback(true)
    },
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    // 富文本开始

    // 富文本结束

    handleChangeF(e) {
      this.r_channel_id = e;
      // 父类渠道
      this.channel_parent = this.bookObj[e].parent_name;
      console.log(this.bookObj[e]);
      console.log(this.channel_parent.indexOf("迈步"));
    },
    radioChangeA(e) {
      // 自动生成 或 手动生成
    },
    radioChangeB(e) {
      // 内推链接 或 外推链接
      console.log(e.target.value);
      this.contentData[this.content_index].spread_type = e.target.value;
    },
    handleChangeB(e) {
      // 阅读类型
      this.contentData[this.content_index].read_type = e;
    },
    changeEditorS(e) {
      // 富文本的值
    },
    // 切换显示的内容
    changeMaterial(e, index) {
      this.contentData.forEach((res) => {
        res.select_status = false;
      });
      this.contentData[index].select_status = true;
      this.content_index = index;
    },
    // 新建素材
    addContent() {
      let obj = {
        build_qrcode: "1", // 生成二维码，1=自动生成
        spread_name: "", // 推广链接名称
        spread_type: 1, // 推广链接类型，0=外推，1=内推
        read_type: 1, // 阅读类型，1=继续阅读，2=历史记录
        message_title: "", // 微信图文标题
        message_auth: "", // 微信图文作者
        message_content: "<p><br></p>", // 正文。<p><br></p>这是默认值，得用html标签的形式，不能用""或null之类的
        message_cover: "", // 封面
        message_foot_img: "", // 图文底图
        message_continue_read: "", // 继续阅读底图
        spread_book_id: null, // 推广书籍第三方id：read_type=1必传
        spread_chapter_id: null, // 推广书籍章节：read_type=1必传
        select_status: false, // 选中状态,true为选中,false为不选中
        message_show_foot_img: "", // 用于显示的二维码底图
      };
      obj.for_id = new Date().getTime(); // 利用时间戳来当成唯一id
      this.contentData.push(obj);
    },

    // 获取图库素材
    getImgRequest(e) {
      // 获取要选择的素材
      let that = this;
      this.img_search_loading = true;
      if (e == 1) {
        // 选择封面
        materialLocalMessage({
          // 1=历史标题，2=封面图，3=微信二维码底图，4=继续阅读底图
          type: 2,
          page: that.img_page,
          limit: that.img_limit,
        }).then((res) => {
          console.log("选择封面", res);
          that.img_search_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            let data = res.data.data.data;
            data.forEach((res) => {
              res.select_img = false;
            });
            that.fmImgData = res.data.data.data;
            that.show_img_total = res.data.data.total;
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        });
      } else if (e == 2) {
        // 二维码图片
        materialLocalMessage({
          // 1=历史标题，2=封面图，3=微信二维码底图，4=继续阅读底图
          type: 3,
          page: that.img_page,
          limit: that.img_limit,
        }).then((res) => {
          that.img_search_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            let data = res.data.data.data;
            data.forEach((res) => {
              res.select_img = false;
            });
            that.ewmImgData = res.data.data.data;
            that.show_img_total = res.data.data.total;
            console.log("微信二维码底图", res);
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        });
      } else if (e == 3) {
        // 阅读原文提示图
        materialLocalMessage({
          // 1=历史标题，2=封面图，3=微信二维码底图，4=继续阅读底图
          type: 4,
          page: that.img_page,
          limit: that.img_limit,
        }).then((res) => {
          console.log("阅读原文提示图", res);
          that.img_search_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            let data = res.data.data.data;
            data.forEach((res) => {
              res.select_img = false;
            });
            that.ydywData = res.data.data.data;
            that.show_img_total = res.data.data.total;
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        });
      }
    },
    // 显示图库弹窗
    selectImg(e) {
      this.img_type = e;
      console.log("显示图库弹窗", e);
      // 获取图库素材
      this.getImgRequest(e);
      this.img_visible = true;
    },
    // 图库弹窗确认
    imgHandleOk() {
      let that = this;
      if (that.img_type == "1") {
        // 选择封面
        this.contentData[this.content_index].message_cover =
          that.fm_select_img_url;
      } else if (that.img_type == "2") {
        // 选择二维码底图
        this.contentData[this.content_index].message_foot_img =
          that.ewm_select_img_url;
        this.contentData[this.content_index].message_show_foot_img =
          that.ewm_show_img_url;
      } else if (that.img_type == "3") {
        // 选择阅读原文提示图片
        this.contentData[this.content_index].message_continue_read =
          that.ydyw_select_img_url;
      }
      that.imgHandleCancel();
    },
    // 取消
    imgHandleCancel() {
      this.img_visible = false;
    },
    // 图库类型切换选择
    imgCallback(e) {
      console.log(e);
      this.img_type = e;
      this.img_page = 1;
      // 获取图库素材
      this.getImgRequest(e);
    },
    // 选择二维码图片
    clickEwmImg(index) {
      let that = this;
      that.ewmImgData.forEach((res) => {
        res.select_img = false;
      });
      that.ewmImgData[index].select_img = true;
      // console.log(that.ewmImgData[index]);
      that.ewm_show_img_url = that.ewmImgData[index].content;
      that.ewm_select_img_url = that.ewmImgData[index].origin_content; // 图片链接
    },
    // 选择封面图片
    clickFmImg(index) {
      let that = this;
      that.fmImgData.forEach((res) => {
        res.select_img = false;
      });
      that.fmImgData[index].select_img = true;
      that.fm_select_img_url = that.fmImgData[index].content; // 图片链接
    },
    // 选择阅读原文提示图
    clickYdywImg(index) {
      let that = this;
      that.ydywData.forEach((res) => {
        res.select_img = false;
      });
      that.ydywData[index].select_img = true;
      that.ydyw_select_img_url = that.ydywData[index].content; // 图片链接
    },
    // 图库分页的切换
    imgPagingChange(e) {
      this.img_page = e;
      // 获取图库素材
      this.getImgRequest(this.img_type);
    },
    // 顶部图片上传 限制用户上传的图片格式和大小。
    beforeUpload(file) {
      console.log("beforeUpload", file);
      this.img_search_loading = true;

      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif";
      if (!isJpgOrPng) {
        this.img_search_loading = false;
        this.$message.error("图片格式只能为：PNG、JPEG、JPG/GIF");
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.img_search_loading = false;
        this.$message.error("图片大小不能超过10MB!");
      }
      return isJpgOrPng && isLt2M;
    },
    uploadChange(info) {
      console.log("图片请求", info);
      let that = this;

      if (info.file.status === "uploading") {
        this.img_search_loading = true;
        return;
      }
      if (info.file.status === "done") {
        console.log("图片请求done", info);
        if (info.file.response) {
          // 图片上传成功，有内容返回

          // this.img_search_loading = false

          // that.loading = false
          // if(that.img_type == '1'){ // 选择封面
          that.getImgRequest(that.img_type);
          // }
          // else if(that.img_type == '2'){ // 选择二维码底图

          // }
          // else if(that.img_type == '3'){ // 选择阅读原文提示图片

          // }
        } else {
          this.img_search_loading = false;
          this.$message.error(`错误：图片上传失败`);
        }
      }

      if (info.file.status === "error") {
        // 上传失败

        this.loading = false;
        this.$message.error(`错误：图片上传失败`);
      }
    },

    // 确认按钮
    addRequest() {
      let that = this;
      let data = that.contentData;
      // console.log("检查内容是否都填",data);
      let reg = /<img/gi;
      // ,"<img data-ratio='1' "
      console.log("正文内容", data[0].message_content);
      // console.log("正文内容-正则",data[0].message_content.replace(reg,"<img data-ratio='1' "));
      if (!that.r_name) {
        that.$message.warning("请填写模板标题");
      } else if (!that.r_channel_id) {
        that.$message.warning("请选择书城");
      } else {
        // 检查内容是否都填
        let data = that.contentData;
        for (let i = 0; i < that.contentData.length; i++) {
          if (!data[i].message_title) {
            that.$message.warning("请输入文章标题");
            return;
          } else if (!data[i].message_cover) {
            that.$message.warning("请选择封面");
            return;
          } else if (
            !data[i].message_content ||
            data[i].message_content == "<p><br></p>"
          ) {
            that.$message.warning("请输入正文");
            return;
          } else if (!data[i].message_foot_img) {
            that.$message.warning("请选择二维码底图");
            return;
          } else if (!data[i].message_continue_read) {
            that.$message.warning("请选择 阅读原文 提示");
            return;
          } else if (!data[i].spread_name) {
            that.$message.warning("请设置推广链接名称");
            return;
          } else if (!data[i].read_type) {
            that.$message.warning("请选择阅读类型");
            return;
          } else if (!data[i].spread_chapter_id) {
            that.$message.warning("请填写 继续阅读第几章");
            return;
          } else if (
            !data[i].spread_book_id &&
            (that.channel_parent == "乐读" ||
              that.channel_parent == "掌读" ||
              that.channel_parent == "文鼎" ||
              that.channel_parent.indexOf("阳光") > -1 ||
              that.channel_parent.indexOf("阅文") > -1 ||
              that.channel_parent.indexOf("花生") > -1)
          ) {
            that.$message.warning("请填写作品ID");
            return;
          }

          // 掌中云、迈步：只需要填写章节ID，作品ID不用显示，传0就可
          if (
            that.channel_parent.indexOf("迈步") > -1 ||
            that.channel_parent.indexOf("掌中") > -1
          ) {
            that.contentData[i].spread_book_id = 0;
          }

          // 对正文的图片进行处理
          data[i].message_content = data[i].message_content.replace(
            reg,
            "<img data-ratio='1' "
          );
        }
        // console.log("执行到这----------");
        that.search_button_loading = true;
        // console.log("that.page_title",that.page_title);
        if (that.page_title == "新建") {
          materialAdd({
            name: that.r_name, // 图文模板
            channel_id: that.r_channel_id, // 选择书城
            content: that.contentData, // 内容
          }).then((res) => {
            console.log("新增", res);
            that.search_button_loading = false;
            if (
              res.data.code == 0 ||
              res.data.code == 200 ||
              res.data.code == 8011
            ) {
              that.$message.success("添加成功");
              setTimeout((res) => {
                that.cancelButton();
              }, 800);
            } else {
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        } else if (that.page_title == "编辑") {
          let data = that.contentData;
          data.forEach((res) => {
            // 检查是否有新增素材或删除素材
            // console.log("res.hasOwnProperty('id')",res.hasOwnProperty('id'));
            if (!res.hasOwnProperty("id")) {
              res.id = 0;
            }
          });
          console.log("data", data);
          materialEdit({
            id: that.r_edit_id, // 编辑的id
            name: that.r_name, // 图文模板
            channel_id: that.r_channel_id, // 选择书城
            content: that.contentData, // 内容
          }).then((res) => {
            console.log("编辑", res);
            that.search_button_loading = false;
            if (
              res.data.code == 0 ||
              res.data.code == 200 ||
              res.data.code == 8011
            ) {
              that.$message.success("编辑成功");
              setTimeout((res) => {
                that.cancelButton();
              }, 800);
            } else {
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        }
      }
    },
    // 取消按钮
    cancelButton() {
      this.$router.replace({ name: "materialList_", params: {} });
    },

    // 解析url
    resolveUrl() {
      if (!this.r_channel_id) {
        this.$message.warning("请选择书城");
      } else {
        this.url_visible = true;
      }
    },
    urlHandleOk() {
      let that = this;
      this.url_confirmLoading = true;
      materialCodeUrl({
        channel_id: this.r_channel_id,
        url: this.r_url,
      }).then((res) => {
        console.log("解析url", res);
        that.url_confirmLoading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.contentData[that.content_index].spread_book_id =
            res.data.data.spread_book_id;
          that.contentData[that.content_index].spread_chapter_id =
            res.data.data.spread_chapter_id;

          that.urlHandleCancel();
          that.$message.success("解析成功");
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    urlHandleCancel() {
      this.r_url = "";
      this.url_confirmLoading = false;
      this.url_visible = false;
    },

    goPage(type) {
      if (type == 1) {
        // 运营书城渠道
        const { href } = this.$router.resolve("/operateChannel");
        window.open(href, "_blank");
      }
    },

    // 标题输入框的相关事件
    titleInputChange(e) {
      // 变化
      console.log("变化", e.target.value);
      let that = this;
      materialLocalMessage({
        type: 1,
        name: e.target.value,
      }).then((res) => {
        console.log("历史标题搜索", res);
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.title_select_control = true;
          that.titleSelectData = res.data.data.data;
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    titleInputFocus(e) {
      // 获取焦点
      // console.log("获取焦点",e);
    },
    titleInputBlur(e) {
      // 失去焦点
      console.log("失去焦点", e);
      // this.title_select_control = false
    },
    // 选中某一个历史下拉框里的内容
    selectTitleCell(item) {
      console.log("item", item);
      this.contentData[this.content_index].message_title = item.content;
      this.title_select_control = false;
    },
  },
};
</script>

<style scoped>
.left-box {
  /* padding: 15px; */
  /* border: 1px solid #ccc; */
  position: sticky;
  top: 70px;
  width: 300px;
  background: #fff;
  padding: 23px;
}
.left-box-border {
  border: 2px solid #409eff;
}
.left-top-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px 12px;
}
.left-cell-top {
  position: relative;
  cursor: pointer;
}
.left-cell-box {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 12px;
}
.left-cell-box-boder {
  border-bottom: 1px solid #e8e8e8;
}
.left-cell-img {
  width: 50px;
  height: 50px;
}
.left-cell-operation {
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
  /* display: flex; */
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px 7px;
  background-color: rgba(0, 0, 0, 0.7);
}
.left-cell-top:hover .left-cell-operation {
  display: flex;
}
.left-cell-box:hover .left-cell-operation {
  display: flex;
}
.left-cell-operation-icon {
  color: #fff;
  font-size: 16px;
}
.left-cell-add {
  text-align: center;
  font-size: 16px;
  padding: 15px 0 5px;
  cursor: pointer;
}

.img-content-null {
  text-align: center;
  text-align: center;
  padding: 50px 0 30px;
}
.img-content-null-text {
  color: #999;
  font-size: 16px;
  margin-top: 20px;
}

.select_img-border {
  /* border: 3px solid #409eff; */
  box-shadow: 0 0 8px 5px #82befd;
}

.img_loading {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
}

.box-radius {
  border-radius: 8px;
}

.title-select-box {
  background-color: #fff;
  box-shadow: 0 0 5px 3px #eee;
  position: absolute;
  width: 100%;
  max-height: 240px;
  z-index: 99;
  top: 45px;
  overflow-y: overlay;
}
.title-select-cell {
  height: 35px;
  line-height: 35px;
  padding: 0 15px;
  cursor: pointer;
}
.title-select-cell:hover {
  background-color: #f2f3f5;
}
</style>
